// Centralised asset URLs (uploaded by user)
export const ASSETS = {
  logo: 'https://customer-assets.emergentagent.com/job_pult-showcase/artifacts/mbsihzux_logo-sticker.png',
  consoleBase: '/console-base.png',
  faderKnob: '/fader-knob.png',
  pultAngle1: 'https://customer-assets.emergentagent.com/job_pult-showcase/artifacts/8nuhrptz_Use%20AI%20Image%20Apr%2024%2C%202026%2C%2013_21_20%20-%20Kopie.jpeg',
  pultAngle2: 'https://customer-assets.emergentagent.com/job_pult-showcase/artifacts/s66hag0u_Use%20AI%20Image%20Apr%2024%2C%202026%2C%2013_23_00.jpeg',
};
